var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReliabilityAndAuthenticity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 22,
    viewBox: "0 0 17 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 3.5H3C2.46957 3.5 1.96086 3.71071 1.58579 4.08579C1.21071 4.46086 1 4.96957 1 5.5V17.5C1 18.0304 1.21071 18.5391 1.58579 18.9142C1.96086 19.2893 2.46957 19.5 3 19.5H6M5 3.5C5 2.96957 5.21071 2.46086 5.58579 2.08579C5.96086 1.71071 6.46957 1.5 7 1.5H9C9.53043 1.5 10.0391 1.71071 10.4142 2.08579C10.7893 2.46086 11 2.96957 11 3.5M5 3.5C5 4.03043 5.21071 4.53914 5.58579 4.91421C5.96086 5.28929 6.46957 5.5 7 5.5H9C9.53043 5.5 10.0391 5.28929 10.4142 4.91421C10.7893 4.53914 11 4.03043 11 3.5M15 10.5V5.5C15 4.96957 14.7893 4.46086 14.4142 4.08579C14.0391 3.71071 13.5304 3.5 13 3.5H11M9 15.5V14.5C9 14.2348 9.10536 13.9804 9.29289 13.7929C9.48043 13.6054 9.73478 13.5 10 13.5H11M14 13.5H15C15.2652 13.5 15.5196 13.6054 15.7071 13.7929C15.8946 13.9804 16 14.2348 16 14.5V15.5M16 18.5V19.5C16 19.7652 15.8946 20.0196 15.7071 20.2071C15.5196 20.3946 15.2652 20.5 15 20.5H14M11 20.5H10C9.73478 20.5 9.48043 20.3946 9.29289 20.2071C9.10536 20.0196 9 19.7652 9 19.5V18.5",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReliabilityAndAuthenticity);
export default __webpack_public_path__ + "static/media/reliability_and_authenticity.366c635b181488721e692b24bcbeab1c.svg";
export { ForwardRef as ReactComponent };